/**
 * Get previous initials
 * If steps contain multiple instance of the same property
 * @param {TriggerMapProps} trigger
 * @param {StepProps} step
 * @param {Map<String, any>} map
 * @param {String} path
 */
const setPreviousInitials = (trigger, step, map, path) => {
  const timeline = /** @type {TimelineMapProps} */ (trigger.get("timeline"));

  if (timeline.get("type") !== "timeline") {
    map.set("last-initial", null);
    return;
  }

  const data = /** @type {Map<String, any>} */ (step.get("data"));
  const current = data.get("number");
  const steps = /** @type {StepsMapProps} */ (timeline.get("steps"));

  let last = null;

  for (const [index, previous] of steps) {
    if (current) {
      if (index < current) {
        const pure = /** @type {StepPureProps} */ (previous.get("pure"));
        const match = pure.get(path);

        if (match) {
          last = match;
        }
      }
    }

    map.set("last-initial", last);
  }
};

export default setPreviousInitials;
